import { createFileRoute } from '@tanstack/react-router'
import { CheckRun } from '@thom/folio-ui/pages/checks/run'

export const Route = createFileRoute('/_authenticated/checks/$run')({
	component: () => (
		<div className='mx-auto w-full max-w-5xl'>
			<CheckRun />
		</div>
	),
})
